module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title-operator-address":"Anlagenbetreiber","not-recorded-yet":"Noch nicht erfasst","not-recorded":"nicht erfasst"},"fr":{"not-recorded":"pas saisi","not-recorded-yet":"Pas encore saisi","title-operator-address":"Exploitant d’installations"},"it":{"not-recorded":"non registrato","not-recorded-yet":"Non ancora registrato","title-operator-address":"Operatore dell\u0027impianto"}}')
  delete Component.options._Ctor
}
